<template>
  <div>
    <navigation />
    <topnav />
    <div class="stat-container">
      <div style="padding: 6px 12px">
        <button @click="getStat()">查看统计</button>
        <button @click="showTask = !showTask">任务列表</button>
        <button @click="taskIds = taskList.map(v => v.taskId)">全选任务</button>
        <select v-model="customerId">
          <option v-for="customer of customerList" :key="`customer${customer.userId}`" :value="customer.userId">{{
            customer.userName
          }}</option>
        </select>
      </div>
      <div class="task-info" v-if="showTask">
        <div v-for="task of taskList" :key="`task${task.taskId}`" style="display: inline-block; margin: 6px 12px;">
          <input
            type="checkbox"
            v-model="taskIds"
            :value="task.taskId"
            style="vertical-align: middle;margin-right: 8px;"
          />
          <span>{{ task.taskName }}</span>
        </div>
      </div>
      <div v-if="statList && statList.length > 0" style="overflow: scroll;">
        <table width="100%" class="table">
          <thead>
            <tr>
              <th>任务名</th>
              <th v-for="c of statClassList" :key="`class${c.id}`">{{ c.name }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="t of statTaskList" :key="`task${t.id}`">
              <td>{{ t.name }}</td>
              <td v-for="c of statClassList" :key="`class${c.id}`">
                {{ getCount(t.id, c.id) }}
              </td>
            </tr>
            <tr>
              <td>总计</td>
              <td v-for="c of statClassList" :key="`class${c.id}`">
                {{ getCount(0, c.id) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import topnav from '@/components/topnav';
import navigation from '@/components/navigation';

export default {
  data: function() {
    return {
      customerId: null,
      customerList: [],
      taskList: [],
      taskIds: [],
      showTask: true,
      statList: [],
      statClassList: [],
      statTaskList: [],
    };
  },
  components: {
    topnav,
    navigation,
  },
  watch: {
    customerId: function() {
      this.getTaskList();
      this.taskList = [];
      this.taskIds = [];
    },
  },
  mounted: function() {
    this.getUserList();
  },
  methods: {
    getCount(taskId, classId) {
      if (taskId !== 0) {
        let res = this.statList.find(v => v.id === taskId && v.class_ids === classId);
        if (res) return res.count;
        return '-';
      } else {
        return this.statList.filter(v => v.class_ids === classId).reduce((t, i) => (t += parseInt(i.count)), 0);
      }
    },
    getUserList() {
      api
        .getUserList({ p: 0, s: 999, r: 2, stat: 0 })
        .then(res => {
          this.customerList = res.data.users;
          // 优先默认客户为海深安检
          this.customerId = this.customerList[
            this.customerList.findIndex(v => v.userName === '海深安检')
              ? this.customerList.findIndex(v => v.userName === '海深安检')
              : 0
          ].userId;
          this.getTaskList();
        })
        .catch(() => {});
    },
    getTaskList() {
      api
        .getTaskListByUser({ userId: this.customerId })
        .then(res => {
          this.taskList = [];
          this.taskList = res.data.tasks;
        })
        .catch(() => {});
    },
    getStat() {
      api
        .getStatistics({ tid: this.taskIds, ob: 'class' })
        .then(res => {
          this.showTask = false;
          res.data.forEach(v => {
            if (this.statClassList.every(t => t.id !== v.class_ids))
              this.statClassList.push({ id: v.class_ids, name: v.className });
            if (this.statTaskList.every(t => t.id !== v.id)) this.statTaskList.push({ id: v.id, name: v.name });
          });
          this.statList = res.data;
        })
        .catch(err => {
          window.console.log(err);
        });
    },
  },
};
</script>
<style scoped>
p {
  margin: 0px;
}
table {
  border-collapse: collapse;
  margin: 0px;
  text-align: left;
  font-size: 14px;
  margin-top: 18px;
}
table th,
table td {
  padding-left: 24px;
}
table thead tr {
  height: 54px;
  font-weight: 500;
  background: #fafafa;
}
table tr {
  border-bottom: 1px solid #eeeeee;
  height: 54px;
}
table tbody {
  color: #595959;
}
select {
  width: 110px;
  height: 33px;
  appearance: none;
  background-image: url('~@/assets/select-arrow.png');
  background-repeat: no-repeat;
  background-position: 90%;
  background-size: 14px;
  background-color: #fafafa;
  color: #595959;
  padding: 9px 12px;
  font-size: 14px;
  line-height: 100%;
  outline: none;
  border-radius: 4px;
  border: 1px solid #dddddd;
}
button {
  height: 33px;
  vertical-align: top;
  margin-right: 18px;
}
</style>
